class Selectbox {
  listSelectbox = {}
  constructor () {
    this.init()
    window.selectboxHandler = this
  }

  init () {
    $('.selectbox').each((index, element) => {
      this.initSelectItem($(element))
    })
  }

  initSelectItem ($select) {
    const selectId = $select.attr('id')
    this.listSelectbox[selectId] = {
      select: $select,
      id: selectId,
      isSingle: $select.data('single-select')
    }
    // console.log(this.listSelectbox)
    $select.find('.selectbox-label').click(event => {
      this.openItem($(event.currentTarget).closest('.selectbox'))
    })

    $(document).click(event => {
      if (!$(event.target).closest('.selectbox').length) {
        const $openSelectboxes = $('.selectbox')
        this.closeItem($openSelectboxes)
      } else {
        const clickedSelectbox = $(event.target).closest('.selectbox')
        const $otherSelectboxes = $('.selectbox').not(clickedSelectbox)
        this.closeItem($otherSelectboxes)
      }
    })

    $select.find('.selectbox-option').click(event => {
      this.handleClickOption($(event.currentTarget))
    })

    $select.find('.selectbox-option-child').each((index, element) => {
      const $child = $(element)
      const parentId = $child.data('parent')
      const $parent = $select.find('.selectbox-option[data-id="' + parentId + '"]')
      $child.closest('li').insertAfter($parent.closest('li'))
    })

    $select.find('.selectbox-clear').click(event => {
      window.selectboxHandler.clear($select)
    })
  }

  updateLabel ($select) {
    const selectedOptions = this.getAllSelectedOptionsObject($select)
    if (selectedOptions.length) {
      const selectedLabels = selectedOptions.map(option => option.label)
      /// $select.find('.selectbox-label .selectbox-label-text').text(selectedLabels.join(', '))
      if ($select.data('single-select')) {
        $select.find('.selectbox-label .selectbox-label-text').text(selectedLabels[0])
      }
    } else {
      $select.find('.selectbox-label .selectbox-label-text').text($select.data('label'))
    }
  }

  handleClickOption ($option) {
    const $select = $option.closest('.selectbox')
    const $optionHasClass = $option.hasClass('selected')
    if ($select.data('single-select')) {
      $select.find('.selectbox-option').each((index, tempOption) => {
        $(tempOption).removeClass('selected')
      })
      if ($optionHasClass) {
        $option.removeClass('selected')
      } else {
        $option.addClass('selected')
      }
    } else {
      $option.toggleClass('selected')
    }
    this.updateLabel($select)
    $select.trigger('onOptionSelected')
  }

  openItem ($select) {
    $select.find('.selectbox-options').slideToggle()
    $select.find('.arrow-select svg').toggleClass('rotate')
  }

  closeItem ($select) {
    $select.find('.selectbox-options').slideUp()
    $select.find('.arrow-select svg').removeClass('rotate')
  }

  getAllSelectedOptions ($select) {
    const selectedOptions = []
    $select.find('.selectbox-option.selected').each((index, element) => {
      selectedOptions.push($(element).data('value'))
    })
    return selectedOptions
  }

  clear ($select) {
    $select.find('.selectbox-option.selected').removeClass('selected')
    $select.trigger('cleared')
  }

  setSelectedOptions ($select, selectedOptions) {
    $select.find('.selectbox-option').each((index, element) => {
      if (selectedOptions.includes($(element).data('value'))) {
        $(element).addClass('selected')
      }
    })
  }

  getAllSelectedOptionsObject ($select) {
    const selectedOptions = []
    $select.find('.selectbox-option.selected').each((index, element) => {
      selectedOptions.push({
        value: $(element).data('value'),
        label: $(element).data('label')
      })
    })
    return selectedOptions
  }
}

export default Selectbox
